export default "__VITE_ASSET__HP2au09q__"